// Marks the sentinel history entry. It must be a query param rather than a hash: checkout strips
// the hash with its own replaceState (use-checkout-vm.ts), which would silently erase the marker.
// react-router-dom 6.24.1 — a same-URL sentinel is indistinguishable from the real entry to the
// router, which is what made Back a no-op once two adjacent entries shared a URL.
const SENTINEL_PARAM = 'sentinel';

const searchHasSentinel = (search: string) => new URLSearchParams(search).has(SENTINEL_PARAM);

// Reads the live URL rather than useLocation, which lags a render on a fast open→close.
const isOnSentinelEntry = () => searchHasSentinel(window.location.search);

// Identifies the page a location points at, ignoring the sentinel. A sentinel push is an internal
// history artifact, not a page change, but it still mints a fresh location.key — so anything that
// reacts to "the user navigated" must compare this rather than the key, or opening a managed modal
// looks like a navigation and immediately undoes itself.
const toNavIdentity = ({ pathname, search }: { pathname: string; search: string }) => {
  const params = new URLSearchParams(search);
  params.delete(SENTINEL_PARAM);
  const query = params.toString();
  return `${pathname}${query ? `?${query}` : ''}`;
};

// react-router's own history index. A POP to a lower index is Back, to a higher one Forward — the
// popstate event itself carries no direction.
const readHistoryIdx = () => (window.history.state as { idx?: number } | null)?.idx;

export { SENTINEL_PARAM, isOnSentinelEntry, readHistoryIdx, searchHasSentinel, toNavIdentity };
